import { FileUpload } from "@mui/icons-material";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Skeleton,
  Snackbar,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import store from "../../../Store";
import { CommonShortCutAction } from "../../../Store/CommonShortCutsReducer";
import { DisbursementBalanceTransferReducerAction } from "../../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import axios from "axios";
import FileUploadAreaAndPreview from "../../../CustomComponents/FileUploadAreaAndPreview";
import { FileUploadAreaAndPreviewReducerAction } from "../../../Store/FileUploadAreaAndPreviewReducer";

const ChequeHandOverAllocationOrAuthorizeGrid = ({
  disbursementDetailTabValue,
}) => {
  //Importing Hooks
  const dispatch = useDispatch();
  //Selectors from redux store
  const datarows = useSelector(
    (state) => state.disbursementBalanceTransfer.gridRows
  );
  const chequeHandOverOrAuthorizeDlgData = useSelector(
    (state) =>
      state.disbursementBalanceTransfer.chequeHandOverOrAuthorizeDlgData
  );
  const fileUploadAreaOpen = useSelector(
    (state) => state.disbursementBalanceTransfer.chequeHandOverUploadAreaOpen
  );

  const fileUploadAreaProps = { maxFileCount: 1 };

  //SnackBar Handler for Cheque HandOver or Authorization.
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const originalColumns = [
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      headerAlign: "center",
      align: "left",
      flex: 150,
      editable: false,
      type: "string",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "chequeNum",
      headerName: "Cheque Number",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "right",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "chequeMode",
      headerName: "Cheque Mode",
      headerAlign: "center",
      align: "left",
      flex: 150,
      editable: false,
      type: "string",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "chequePrintAt",
      headerName: "Cheque Print At",
      headerAlign: "center",
      align: "left",
      flex: 150,
      editable: false,
      type: "string",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "chequePrintLocation",
      headerName: "Cheque Print Location",
      headerAlign: "center",
      type: "string",
      align: "left",
      flex: 200,
      editable: false,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "chequeShflLocation",
      headerName: "Cheque SHFL Location",
      headerAlign: "center",
      align: "left",
      type: "string",
      flex: 200,
      editable: false,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      type: "string",
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "favouringName",
      headerName: "Favouring Name",
      headerAlign: "center",
      align: "left",
      type: "string",
      flex: 200,
      editable: false,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "amount",
      headerName: "Amount",
      headerAlign: "center",
      align: "right",
      type: "number",
      flex: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: (params) => {
        let value =
          params.value === undefined ||
          params.value === null ||
          params.value === "" ||
          params.value === "0"
            ? 0
            : Number(params.value) <= 0
            ? 0
            : parseInt(params.value).toLocaleString("en-IN");
        return value;
      },
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "chequeAllocationMode",
      headerName: "Cheque Allocation Mode",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "bankBranchShflBank",
      headerName: "Bank Branch SHFL Bank",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "bankBranchGl",
      headerName: "Bank Branch GL",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
    {
      field: "requestStatus",
      headerName: "Disbursement Status",
      headerAlign: "center",
      type: "string",
      flex: 300,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ? "disabledColumnColor" : "",
    },
  ];

  const [gridColumns, setGridColumns] = React.useState(originalColumns);

  const [loading, setLoading] = useState(true);

  // short cut
  const cancelRef = useRef(null);
  const yesRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "q") {
        cancelRef.current.click();
      } else if (charCode === "y") {
        yesRef.current.click();
      }
    }
  };

  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementCreate",
        })
      );
    }
  };

  useEffect(() => {
    // only 2 modes are CHEQUE_HANDOVER_AUTHORIZATION & CHEQUE_HANDOVER_ALLOCATION.
    const chequeRows =
      chequeHandOverOrAuthorizeDlgData.dlgMode === "CHEQUE_HANDOVER_ALLOCATION"
        ? datarows.filter(
            (record) =>
              record.paymentMode === "CHEQUE" &&
              (record.requestStatus === "Approved , Cheque HandOver Pending" ||
                record.requestStatus ===
                  "Approved , Cheque Authourization Pending")
          )
        : datarows.filter(
            (record) =>
              record.paymentMode === "CHEQUE" &&
              record.requestStatus ===
                "Approved , Cheque Authourization Pending"
          );
    let updatedColumns = [];
    const lastColumn = originalColumns.pop();
    if (
      chequeHandOverOrAuthorizeDlgData.dlgMode === "CHEQUE_HANDOVER_ALLOCATION"
    ) {
      // here the last column poped is disbursement status of that payment record.
      const newColumns = [
        {
          field: "chequeHandoverDate",
          headerName: "Cheque HandOver Date",
          headerAlign: "center",
          align: "right",
          flex: 300,
          type: "date",
          hideable: false,
          editable: true,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          cellClassName: (params) =>
            !params.colDef.editable ? "disabledColumnColor" : "",
          valueFormatter: (params) =>
            params?.value !== null &&
            params?.value !== undefined &&
            params?.value !== ""
              ? dayjs(params?.value).format("DD/MM/YYYY")
              : null,
        },
        {
          field: "handOverFile",
          headerName: "Hand Over File",
          headerAlign: "center",
          align: "center",
          flex: 300,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          hideable: false,
          editable: false,
          renderCell: (params) => {
            return params?.value === null ||
              params?.value === undefined ||
              params?.value === "" ? (
              <React.Fragment>
                <Tooltip title="Hand Over File Upload">
                  <FileUpload
                    fontSize="large"
                    sx={{ color: "#004A92", fontWeight: 7000 }}
                    onClick={() => {
                      dispatch(
                        FileUploadAreaAndPreviewReducerAction.updateUploadAreaFiles(
                          []
                        )
                      );
                      dispatch(
                        FileUploadAreaAndPreviewReducerAction.updateLinkKey(
                          params.row.disbHeaderKey
                        )
                      );
                      dispatch(
                        DisbursementBalanceTransferReducerAction.updateChequeHandOverUploadAreaOpen(
                          true
                        )
                      );
                    }}
                  ></FileUpload>
                </Tooltip>
              </React.Fragment>
            ) : (
              <React.Fragment>{loadHandOverFileNames(params)}</React.Fragment>
            );
          },
        },
      ];
      updatedColumns = originalColumns.concat(newColumns);
      updatedColumns.push(lastColumn);
      setGridColumns(updatedColumns);
    } else {
      // CHEQUE_HANDOVER_AUTHORIZATION case grid.
      const newColumns = [
        {
          field: "chequeHandoverDate",
          headerName: "Cheque HandOver Date",
          headerAlign: "center",
          align: "right",
          flex: 300,
          type: "date",
          hideable: false,
          editable: false,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          cellClassName: (params) =>
            !params.colDef.editable ? "disabledColumnColor" : "",
          valueFormatter: (params) =>
            params?.value !== null &&
            params?.value !== undefined &&
            params?.value !== ""
              ? dayjs(params?.value).format("DD/MM/YYYY")
              : null,
        },
      ];
      updatedColumns = originalColumns.concat(newColumns);
      updatedColumns.push(lastColumn);
      setGridColumns(updatedColumns);
    }
    dispatch(
      DisbursementBalanceTransferReducerAction.updateChequeHandOverAllocationOrAuthorizationGridRows(
        chequeRows
      )
    );
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const loadHandOverFileNames = (params) => {
    return (
      <Chip
        label={
          <pre
            style={{
              margin: 0,
              fontSize: "0.8rem",
              padding: 0,
              fontWeight: 450,
              fontFamily: ["Roboto"].join(","),
            }}
          >
            {params.value}
          </pre>
        }
        component="div"
        sx={{
          color: "#004A92",
          bgcolor: "lightskyblue",
          width: "90%",
          height: "auto",
        }}
        onClick={() => {
          // open the preview dialog & load the File or Files For Preview
          const data =
            store.getState().disbursementBalanceTransfer
              .chequeHandOverOrAuthorizeDlgData;
          const gridRowFilesRecord = data.dlgGridRows.filter(
            (record) => record.disbHeaderKey === params.row.disbHeaderKey
          );
          dispatch(
            FileUploadAreaAndPreviewReducerAction.updateUploadAreaFiles(
              gridRowFilesRecord[0]?.handOverFiles
                ? gridRowFilesRecord[0]?.handOverFiles
                : []
            )
          );
          dispatch(
            FileUploadAreaAndPreviewReducerAction.updateLinkKey(
              params.row.disbHeaderKey
            )
          );
          dispatch(
            DisbursementBalanceTransferReducerAction.updateChequeHandOverUploadAreaOpen(
              true
            )
          );
        }}
      />
    );
  };

  const isCellEditable = (params) => {
    if (
      params.field === "chequeHandoverDate" &&
      chequeHandOverOrAuthorizeDlgData.dlgMode === "CHEQUE_HANDOVER_ALLOCATION"
    ) {
      return true;
    }
    return false;
  };

  const updateUploadedFilesToChequeRows = () => {
    // first upload the configured accepted files to corresponding grid record.
    const activeFileUploadAreaData =
      store.getState().fileUploadAreaAndPreview.activeFileUploadAreaData;
    const dlgGridRows = chequeHandOverOrAuthorizeDlgData.dlgGridRows;
    const updatedRows = [...dlgGridRows].map((record) => {
      if (record.disbHeaderKey === activeFileUploadAreaData.linkKey) {
        let row = { ...record };
        let fileNames = "";
        activeFileUploadAreaData.uploadAreaFiles.forEach((file) => {
          fileNames = `${fileNames}` + `${file.name},\n`;
        });
        row.handOverFile = fileNames;
        row.handOverFiles = activeFileUploadAreaData.uploadAreaFiles;
        return row;
      }
      return record;
    });
    dispatch(
      DisbursementBalanceTransferReducerAction.updateChequeHandOverAllocationOrAuthorizationGridRows(
        [...updatedRows]
      )
    );
    // the rest the uplaod area and close the dlg.
    dispatch(FileUploadAreaAndPreviewReducerAction.updateUploadAreaFiles([]));
    dispatch(FileUploadAreaAndPreviewReducerAction.updateLinkKey(null));
    dispatch(
      DisbursementBalanceTransferReducerAction.updateChequeHandOverUploadAreaOpen(
        false
      )
    );
  };

  const onSelectionModelChange = (selectionModel, details) => {
    const chequeHandOverOrAuthorizeDlgData =
      store.getState().disbursementBalanceTransfer
        .chequeHandOverOrAuthorizeDlgData;
    let latestGridRows = chequeHandOverOrAuthorizeDlgData?.dlgGridRows;
    let updatedRecords = [];
    updatedRecords = [...latestGridRows].map((record) => {
      let row = { ...record };
      row.isRowSelected = [...selectionModel].includes(record.id);
      return row;
    });
    dispatch(
      DisbursementBalanceTransferReducerAction.updateChequeHandOverAllocationOrAuthorizationGridRows(
        [...updatedRecords]
      )
    );
  };

  const cellChangeHandler = async (params) => {
    const chequeHandOverOrAuthorizeDlgData =
      store.getState().disbursementBalanceTransfer
        .chequeHandOverOrAuthorizeDlgData;
    const latestGridRows = chequeHandOverOrAuthorizeDlgData?.dlgGridRows;
    const rowDataIndex = [...latestGridRows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = latestGridRows[rowDataIndex];
    let updatedRecords = [];

    if (params.field === "chequeHandoverDate") {
      updatedRecords = await Promise.all(
        (updatedRecords = [...latestGridRows].map(async (row) => {
          if (row.id === activeRecord.id) {
            let recordValue = { ...row };
            const chequeHandOverDate =
              await validateChequeHandOverDatesAcrossCheques(
                params.value,
                activeRecord
              );
            recordValue.chequeHandoverDate = chequeHandOverDate;
            return recordValue;
          } else {
            return row;
          }
        }))
      );
      dispatch(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverAllocationOrAuthorizationGridRows(
          [...updatedRecords]
        )
      );
    }
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const validateChequeHandOverDatesAcrossCheques = async (
    handoverDate,
    activeRecord
  ) => {
    if (handoverDate) {
      // cheque handover date should not be less than disbursement Date.
      const currentCycleDisbDate = new Date(
        disbursementDetailTabValue.dateOfDisb
      );
      const convertedChequeHandoverDate = new Date(handoverDate);
      if (
        new Date(convertedChequeHandoverDate.toDateString()) <
        new Date(currentCycleDisbDate.toDateString())
      ) {
        setMessage(
          "Cheque HandOver Date Cannot be less than the Current Cycle Disbursement Date."
        );
        setAlertType("error");
        openAlertHandler();
        return null;
      }

      dispatch(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
          true
        )
      );
      dispatch(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
          "Validating the Cheque HandOver Date across existing Authorised Cheques."
        )
      );
      try {
        const response = await axios.post(
          "/disbursement/validateChequeHandoverDates",
          {
            applicationNum: activeRecord.applicationNum,
            handoverDates: [handoverDate],
          }
        );
        if (response.status === 200) {
          setTimeout(() => {
            dispatch(
              DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
                "Cheque HandOver Date is Valid for Processing Cheque HandOver Allocation."
              )
            );
            setMessage(
              "Cheque HandOver Date is Valid for Processing Cheque HandOver Allocation."
            );
            setAlertType("success");
            openAlertHandler();
            setTimeout(() => {
              dispatch(
                DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
                  false
                )
              );
            }, 1000);
          }, 2000);
          return handoverDate;
        }

        if (response.status === 206) {
          setTimeout(() => {
            dispatch(
              DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
                "Cheque HandOver Date is InValid Can't Proceed for Cheque HandOver Allocation."
              )
            );
            setMessage(
              "Cheque HandOver Date is InValid Can't Proceed for Cheque HandOver Allocation."
            );
            setAlertType("error");
            openAlertHandler();
            setTimeout(() => {
              dispatch(
                DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
                  false
                )
              );
            }, 1000);
          }, 2000);
          return null;
        }
      } catch (error) {
        console.log(error);
        setTimeout(() => {
          dispatch(
            DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
              "Error In API processing " + error.message
            )
          );
          setMessage("Error In API processing " + error.message);
          setAlertType("error");
          openAlertHandler();
          setTimeout(() => {
            dispatch(
              DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
                false
              )
            );
          }, 1000);
        }, 2000);
        return null;
      }
    } else {
      setMessage("Invalid Cheque Handover Date");
      setAlertType("error");
      openAlertHandler();
      return handoverDate;
    }
  };

  return (
    <React.Fragment>
      {chequeHandOverOrAuthorizeDlgData?.spinnerFlag && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{chequeHandOverOrAuthorizeDlgData?.spinnerText}</p>
            </Box>
          </Backdrop>
        </>
      )}
      {loading && (
        <Box sx={{ backgroundColor: "white", minHeight: "320px" }}>
          <Skeleton
            variant="rounded"
            animation="wave"
            width="100%"
            height={
              window.innerHeight > 650 ? window.innerHeight / 1.8 : "400px"
            }
          />
        </Box>
      )}
      {!loading && (
        <Box
          sx={{
            "& .disabledColumnColor": { backgroundColor: "#D7D7D7" },
          }}
        >
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            density={"comfortable"}
            gridHeight={
              window.innerHeight > 650 ? window.innerHeight / 1.8 : 400
            }
            checkboxSelection={
              chequeHandOverOrAuthorizeDlgData?.dlgGridRows.length > 0
            }
            rowHeight={80}
            rows={chequeHandOverOrAuthorizeDlgData?.dlgGridRows}
            columns={gridColumns}
            pageSize={10}
            pageSizeOptions={[10]}
            onCellEditCommit={(params) => {
              cellChangeHandler(params);
            }}
            onCellKeyDown={(params, event) => {}}
            onCellDoubleClick={(params, event) => {}}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
            isCellEditable={isCellEditable}
            onSelectionModelChange={(selectionModel, details) => {
              onSelectionModelChange(selectionModel, details);
            }}
          />
        </Box>
      )}
      <Dialog
        open={fileUploadAreaOpen}
        fullScreen={true}
        aria-describedby="alert-dialog-slide-description"
      >
        <Paper>
          <DialogTitle>{"Hand Over File Upload Area"}</DialogTitle>
          <DialogContent>
            <h4>{"Hand Over File Upload Area"}</h4>
            {<FileUploadAreaAndPreview {...fileUploadAreaProps} />}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                updateUploadedFilesToChequeRows();
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
        sx={{ marginTop: "60px !important" }}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default ChequeHandOverAllocationOrAuthorizeGrid;
